import React from 'react';
import { IT, FR, DE, GB, ES, BE, NL, AT, IE, LU, SE, NO, US, CA, JP } from 'country-flag-icons/react/3x2';

const FLAGS = { IT, FR, DE, GB, ES, BE, NL, AT, IE, LU, SE, NO, US, CA, JP };

export const COUNTRIES = [['IT', 'Italia'], ['FR', 'Francia'], ['DE', 'Germania'], ['GB', 'Regno Unito'], ['ES', 'Spagna'], ['BE', 'Belgio'], ['NL', 'Olanda'], ['AT', 'Austria'], ['IE', 'Irlanda'], ['LU', 'Lussemburgo'], ['SE', 'Svezia'], ['NO', 'Norvegia'], ['US', 'Stati Uniti'], ['CA', 'Canada'], ['JP', 'Giappone']];

export function Flag({ code, className = 'w-5 h-auto' }) {
  const F = FLAGS[(code || '').toUpperCase()];
  return F ? <F title={code} className={`${className} inline-block rounded-[2px] shrink-0`} data-testid={`flag-${code}`} /> : null;
}

export function CountryLabel({ code, name }) {
  return <span className="inline-flex items-center gap-2"><Flag code={code} />{name}</span>;
}
